module.exports = __webpack_public_path__ + "aa4face2a4d2b765316482ea5cd34b69.png";